import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { Alert } from "antd";

/**
 * Player de HLS usado para conferir o backup gerado pelo transcoder.
 * Safari/iOS tocam m3u8 nativamente; nos demais navegadores o hls.js faz o
 * trabalho via Media Source Extensions.
 */
export default function HlsPlayer({ src, poster, altura = 400 }) {
  const videoRef = useRef(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return undefined;

    setErro(null);

    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
      return undefined;
    }

    if (!Hls.isSupported()) {
      setErro("Este navegador não suporta HLS.");
      return undefined;
    }

    const hls = new Hls({ enableWorker: true });
    hls.loadSource(src);
    hls.attachMedia(video);
    hls.on(Hls.Events.ERROR, (_evento, dados) => {
      // Só erro fatal interessa: o hls.js se recupera sozinho dos demais.
      if (dados?.fatal) {
        setErro(`Falha ao carregar o vídeo (${dados.type}).`);
      }
    });

    return () => hls.destroy();
  }, [src]);

  return (
    <div style={{ width: "100%" }}>
      {erro && <Alert type="error" message={erro} style={{ marginBottom: 10 }} />}
      <video
        ref={videoRef}
        poster={poster}
        controls
        playsInline
        style={{ width: "100%", height: altura, backgroundColor: "#000", borderRadius: 8 }}
      />
    </div>
  );
}
